<nav
  [attr.aria-label]="content?.ariaLabel"
  [attr.aria-labelledby]="content?.ariaLabelledby"
  class="idp--tabs"
  role="navigation"
>
  <ul #tabList class="idp--tabs__nav" role="tablist">
    <li
      (click)="selectTab(tabItem, tab, i)"
      *ngFor="let tab of content?.tabs; let i = index"
      [ngClass]="{
        'idp--tabs__nav-item--selected': tab.active,
        'idp--tabs__nav-item--disabled': !tab.active
      }"
      class="idp--tabs__nav-item"
      role="presentation"
    >
      <a
        #tabItem
        (click)="$event.preventDefault()"
        (focus)="onTabFocus(tabItem, i)"
        [attr.aria-controls]="tab.id"
        [attr.aria-selected]="tab.active"
        [attr.tabindex]="tab.active ? 0 : -1"
        [title]="tab.content?.heading"
        [ngClass]="
          tab.content.isDisabled
            ? 'idp--tabs__nav-link disabled-tab'
            : 'idp--tabs__nav-link'
        "
        draggable="false"
        href="#"
        id="{{ tab.id }}-header"
        role="tab"
      >
        <ng-container *ngIf="tab.content.headerTemplate">
          <ng-template
            *ngTemplateOutlet="
              tab.content.headerTemplate;
              context: { tabData: { index: i, name: tab.content.heading } }
            "
          ></ng-template>
        </ng-container>
        <ng-container *ngIf="!tab.content?.headerTemplate">
          {{ tab.content?.heading }}
        </ng-container>
      </a>
    </li>
  </ul>
</nav>
